import { Routes } from '@angular/router';
import { KidsPage } from './kids.page';
import { v2On } from '../v2/ui-v2.guard';


export const kidsRoutes: Routes = [
    {
        path: 'kids',
        component: KidsPage,
        children: [
            {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
            },
            // v2 version shares the URL of the current page and is picked by the v2 switch.
            {
                path: 'add',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/add-kid-v2.page').then( m => m.AddKidsV2Page)
            },
            {
                path: 'add',
                loadComponent: () => import('./add-kids/add-kids.page').then( m => m.AddKidsPage)
            },
            {
                path: 'link-hub',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/link-hub-v2.page').then(m => m.LinkHubV2Page)
            },
            {
                path: 'link-hub',
                loadComponent: () => import('./link-hub/link-hub.page').then(m => m.LinkHubPage)
            },
            // {
            //     path: 'trips',
            //     component: TripsPage
            // },
            {
                path: 'list',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/list-kids-v2.page').then( m => m.ListKidsV2Page)
            },
            {
                path: 'list',
                loadComponent: () => import('./list-kids/list-kids.page').then( m => m.ListKidsPage)
            },
            {
                path: 'details',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/kid-detail-v2.page').then(m => m.KidDetailV2Page)
            },
            {
                path: 'details',
                loadComponent: () => import('./kid-detail/kid-detail.page').then( m => m.KidDetailPage)
            },
            {
                path: 'edit',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/edit-kid-v2.page').then(m => m.EditKidsV2Page)
            },
            {
                path: 'edit',
                loadComponent: () => import('./edit-kids/edit-kids.page').then(m => m.EditKidsPage)
            },
            {
                path: 'bulk-import',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/bulk-import-v2.page').then(m => m.BulkImportV2Page)
            },
            {
                path: 'bulk-import',
                loadComponent: () => import('./bulk-import/bulk-import-kids.page').then(m => m.BulkImportKidsPage)
            },
            {
                path: 'invites',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/invites-v2.page').then(m => m.InvitesV2Page)
            },
            {
                path: 'invites',
                loadComponent: () => import('./invites/invites.page').then(m => m.InvitesPage)
            },
            {
                path: 'requests',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/kids/requests-v2.page').then(m => m.RequestsV2Page)
            },
            {
                path: 'requests',
                loadComponent: () => import('./requests/requests.page').then(m => m.RequestsPage)
            }
        ]
    },
    // {
    //     path: 'tabs/trip-detail',
    //     loadComponent: () => import('./trip-detail/trip-detail.page').then( m => m.TripDetailPage)
    // },
    
];